var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"JoszakiMarkdownTextBlock",domProps:{"innerHTML":_vm._s(_vm.md.render(_vm.text))}})
}
var staticRenderFns = []

export { render, staticRenderFns }